module.exports = __webpack_public_path__ + "static/media/img15.b90d58bc.jpg";